(function () {
  var SESSION_KEY = "mm_pieces_moto_v2";

  var AFAM_HANDLES = {
    "kits-chaines": "kit",
    chaines: "chaine",
    pignons: "pignon",
    couronnes: "couronne",
    "transmission-kits": "kit",
    "transmission-chaines": "chaine",
    "transmission-pignons": "pignon",
    "transmission-couronnes": "couronne",
  };

  var FREINAGE_HANDLES = {
    freinage: "all",
    nissin: "all",
    "cl-brakes": "all",
    "plaquettes-de-frein": "plaquette",
    "disques-de-frein": "disque",
    "supports-etrier": "autre",
    "etriers-de-frein": "autre",
    "maitres-cylindres": "autre",
  };

  var FREINAGE_VENDOR = {
    nissin: "Nissin",
    "cl-brakes": "CL Brakes",
  };

  var GUIDONS_HANDLES = {
    "guidons-motocross": "guidon",
  };

  function readSession() {
    try {
      return JSON.parse(sessionStorage.getItem(SESSION_KEY) || "{}");
    } catch (e) {
      return {};
    }
  }

  function writeSession(data) {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
  }

  function stripLeadingBrand(model, brand) {
    if (!model || !brand) return model || "";
    var re = new RegExp("^" + String(brand).replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s+", "i");
    var out = String(model).replace(re, "").trim();
    return out || model;
  }

  function ccValuesFor(ccMap, brand, model) {
    var raw = ccMap && ccMap[brand + "|" + model];
    if (Array.isArray(raw) && raw.length) return raw.map(String);
    if (raw != null && String(raw) !== "") return [String(raw)];
    var guessed = extractCc(model);
    return guessed ? [guessed] : [];
  }

  function fillSelect(select, values, placeholder, enable, labelFn) {
    if (!select) return;
    select.innerHTML = "";
    var opt0 = document.createElement("option");
    opt0.value = "";
    opt0.textContent = placeholder;
    select.appendChild(opt0);
    (values || []).forEach(function (v) {
      var opt = document.createElement("option");
      opt.value = v;
      opt.textContent = labelFn ? labelFn(v) : v;
      select.appendChild(opt);
    });
    select.disabled = !enable;
  }

  /**
   * Cylindrée lue dans le nom, seulement si c’est un nombre à part.
   * MT-09, ZX-10 : le nombre fait partie du code modèle, pas la cylindrée.
   */
  function extractCc(modelName) {
    if (!modelName) return "";
    var standalone = String(modelName).match(/(?:^|[\s/])(\d{2,4})\b/g);
    if (standalone && standalone.length) {
      var last = standalone[standalone.length - 1].replace(/^[\s/]/, "");
      if (Number(last) >= 50) return last;
    }
    var glued = String(modelName).match(/(\d{2,4})(?=[A-Za-z]?(?:$|[\s/]))/g);
    if (!glued || !glued.length) return "";
    var g = glued[glued.length - 1];
    if (Number(g) < 50) return "";
    return g;
  }

  /** Libellé modèle sans la cylindrée (YZ 250 → YZ). La cylindrée reste dans son champ. */
  function modelLabel(model, cc) {
    if (!model || !cc) return model;
    var re = new RegExp("(^|[\\s/])" + cc + "(?=$|[\\s/])");
    if (!re.test(model)) {
      if (model.length > cc.length && model.slice(-cc.length) === cc) {
        var cut = model.slice(0, -cc.length).replace(/[\s\-/]+$/, "");
        if (cut.length >= 2) return cut;
      }
      return model;
    }
    var next = model.replace(re, "$1").replace(/\s+/g, " ").replace(/\s*\/\s*$/g, "").trim();
    return next || model;
  }

  function modelsForBrand(tree, brand) {
    if (!brand || !tree || !tree[brand]) return [];
    return Object.keys(tree[brand]).sort();
  }

  function ccListForModels(models, brand, ccMap) {
    var seen = {};
    var out = [];
    (models || []).forEach(function (m) {
      ccValuesFor(ccMap, brand, m).forEach(function (cc) {
        if (!seen[cc]) {
          seen[cc] = true;
          out.push(cc);
        }
      });
    });
    return out.sort(function (a, b) {
      return Number(a) - Number(b);
    });
  }

  function filterModelsByCc(models, cc, brand, ccMap) {
    if (!cc) return models || [];
    return (models || []).filter(function (m) {
      return ccValuesFor(ccMap, brand, m).indexOf(String(cc)) !== -1;
    });
  }

  function parseUrlFilters() {
    var params = new URLSearchParams(window.location.search);
    return {
      brand: params.get("filter.p.m.custom.marque") || "",
      model: params.get("filter.p.m.custom.model") || "",
      year: params.get("filter.p.m.custom.annee") || "",
    };
  }

  function buildNativeFilterUrl(baseUrl, brand, model, year) {
    var url = new URL(baseUrl, window.location.origin);
    url.search = "";
    if (brand) url.searchParams.set("filter.p.m.custom.marque", brand);
    if (model) url.searchParams.set("filter.p.m.custom.model", model);
    if (year) url.searchParams.set("filter.p.m.custom.annee", year);
    return url.pathname + url.search;
  }

  function productMatchesMoto(product, brand, model, year) {
    if (!brand && !model && !year) return true;
    // Guidons universels (ex. ODI 1-1/8) : visibles dès qu'une moto est choisie
    if (product.universal) return true;
    if (product.fit && product.fit.length) {
      return product.fit.some(function (key) {
        var parts = key.split("|");
        if (brand && parts[0] !== brand) return false;
        if (model && parts[1] !== model) return false;
        // "*" / vide = toutes années
        if (year && parts[2] && parts[2] !== "*" && parts[2] !== year) return false;
        return true;
      });
    }
    if (product.b && product.m) {
      if (brand && product.b !== brand) return false;
      if (model && product.m !== model) return false;
      if (year && product.y && product.y !== "*" && product.y !== year) return false;
      return true;
    }
    return false;
  }

  function extractHandleFromHref(href) {
    if (!href) return "";
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  function formatStatus(root, key, vars) {
    var tpl = root.getAttribute("data-i18n-" + key) || "";
    if (!tpl || tpl.indexOf("Translation missing") !== -1) return "";
    Object.keys(vars || {}).forEach(function (k) {
      tpl = tpl.split("{{" + k + "}}").join(String(vars[k]));
    });
    return tpl;
  }

  function init(root) {
    var mode = root.getAttribute("data-mode") || "native";
    var collectionHandle = root.getAttribute("data-collection-handle") || "";
    var showType = root.getAttribute("data-show-type") === "true";
    var brandEl = root.querySelector("[data-mm-brand]");
    var typeEl = root.querySelector("[data-mm-type]");
    var modelEl = root.querySelector("[data-mm-model]");
    var ccEl = root.querySelector("[data-mm-cc]");
    var yearEl = root.querySelector("[data-mm-year]");
    var statusEl = root.querySelector("[data-mm-status]");
    var gridEl = document.getElementById("ProductGridContainer");
    var fitmentUrl = root.getAttribute("data-fitment-url");

    var phBrand = brandEl.getAttribute("data-placeholder") || "Marque";
    var phType = typeEl ? typeEl.getAttribute("data-placeholder") || "Type" : "Type";
    var phModel = modelEl.getAttribute("data-placeholder") || "Modèle";
    var phCc = ccEl ? ccEl.getAttribute("data-placeholder") || "Cylindrée" : "Cylindrée";
    var phYear = yearEl.getAttribute("data-placeholder") || "Année";

    var afamData = null;
    var afamCat = AFAM_HANDLES[collectionHandle] || "all";
    var freinageCat = FREINAGE_HANDLES[collectionHandle] || "all";
    var freinageVendor = FREINAGE_VENDOR[collectionHandle] || "";
    var guidonsCat = GUIDONS_HANDLES[collectionHandle] || "all";
    var isFitmentMode = mode === "afam" || mode === "freinage" || mode === "guidons";

    function setStatus(msg) {
      if (!statusEl) return;
      statusEl.textContent = msg || "";
      statusEl.hidden = !msg;
    }

    function collectMatchingHandles(brand, model, year) {
      var handles = [];
      if (!afamData) return handles;
      (afamData.products || []).forEach(function (p) {
        if (mode === "freinage") {
          if (freinageCat !== "all" && p.cat !== freinageCat) return;
          if (freinageVendor && p.vendor !== freinageVendor) return;
        } else if (mode === "guidons") {
          if (guidonsCat !== "all" && p.cat !== guidonsCat) return;
        } else if (afamCat !== "all" && p.cat !== afamCat) {
          return;
        }
        if (!productMatchesMoto(p, brand, model, year)) return;
        if (p.h) handles.push(p.h);
      });
      return handles;
    }

    function applyAfamGridFilter(brand, model, year) {
      if (!gridEl || !afamData) return;
      var allowed = {};
      collectMatchingHandles(brand, model, year).forEach(function (h) {
        allowed[h] = true;
      });

      var items = gridEl.querySelectorAll("#product-grid .grid__item");
      var visible = 0;
      items.forEach(function (item) {
        var link = item.querySelector('a[href*="/products/"]');
        var handle = extractHandleFromHref(link ? link.getAttribute("href") : "");
        var show = !brand && !model && !year ? true : !!allowed[handle];
        item.style.display = show ? "" : "none";
        if (show) visible++;
      });

      if (brand || model || year) {
        setStatus(
          formatStatus(root, "status-catalog", {
            visible: visible,
            total: Object.keys(allowed).length,
          }),
        );
      } else {
        setStatus("");
      }
    }

    function setYearOptions(years, enable) {
      var list = years || [];
      fillSelect(yearEl, list, phYear, !!enable && list.length > 0);
      return list;
    }

    function afamSelectionReady() {
      var cc = ccEl ? ccEl.value : "";
      var concrete = concreteModel(brandEl.value, modelEl.value, cc);
      if (!brandEl.value || !concrete) return false;
      if (ccEl && !ccEl.disabled && ccEl.options.length > 1 && !ccEl.value) return false;
      if (yearEl && !yearEl.disabled && yearEl.options.length > 1 && !yearEl.value) return false;
      return true;
    }

    function modelsForCurrent(brand) {
      var cat = AFAM_HANDLES[collectionHandle] || "all";
      var seen = {};
      (afamData.products || []).forEach(function (p) {
        if (cat !== "all" && p.cat !== cat) return;
        (p.fit || []).forEach(function (key) {
          var parts = key.split("|");
          if (parts[0] === brand && parts[1]) seen[parts[1]] = true;
        });
        if ((!p.fit || !p.fit.length) && p.b === brand && p.m) seen[p.m] = true;
      });
      var list = Object.keys(seen);
      if (list.length) return list.sort();
      return modelsForBrand(afamData && afamData.tree, brand);
    }

    function brandsForCurrent() {
      var cat = AFAM_HANDLES[collectionHandle] || "all";
      var seen = {};
      (afamData.products || []).forEach(function (p) {
        if (cat !== "all" && p.cat !== cat) return;
        if (p.b) seen[p.b] = true;
        (p.fit || []).forEach(function (key) {
          var b = key.split("|")[0];
          if (b) seen[b] = true;
        });
      });
      return (afamData.brands || []).filter(function (b) {
        return seen[b];
      });
    }

    function yearsFor(brand, model) {
      var cat = AFAM_HANDLES[collectionHandle] || "all";
      var seen = {};
      (afamData.products || []).forEach(function (p) {
        if (cat !== "all" && p.cat !== cat) return;
        (p.fit || []).forEach(function (key) {
          var parts = key.split("|");
          if (parts[0] === brand && parts[1] === model && parts[2] && parts[2] !== "*") {
            seen[parts[2]] = true;
          }
        });
      });
      return Object.keys(seen).sort(function (a, b) {
        var na = parseInt(a, 10) || 0;
        var nb = parseInt(b, 10) || 0;
        if (na !== nb) return na - nb;
        return a < b ? -1 : a > b ? 1 : 0;
      });
    }

    var MODEL_GROUP = "\u0001";

    function allModelsFor(brand) {
      return mode === "afam" ? modelsForCurrent(brand) : modelsForBrand(afamData && afamData.tree, brand);
    }

    function shortLabel(brand, model) {
      var label = stripLeadingBrand(model, brand);
      var own = ccValuesFor(afamData && afamData.cc, brand, model);
      if (own.length === 1) label = modelLabel(label, own[0]);
      return label || model;
    }

    function concreteModel(brand, raw, cc) {
      if (!raw) return "";
      if (raw.charAt(0) !== MODEL_GROUP) return raw;
      var label = raw.slice(1);
      var hits = allModelsFor(brand).filter(function (m) {
        return shortLabel(brand, m) === label;
      });
      if (cc) {
        hits = hits.filter(function (m) {
          return ccValuesFor(afamData && afamData.cc, brand, m).indexOf(String(cc)) !== -1;
        });
      }
      return hits.length === 1 ? hits[0] : "";
    }

    function ccsForModelChoice(brand, raw) {
      var pool = allModelsFor(brand);
      if (raw && raw.charAt(0) === MODEL_GROUP) {
        var label = raw.slice(1);
        pool = pool.filter(function (m) {
          return shortLabel(brand, m) === label;
        });
      } else if (raw) {
        pool = [raw];
      }
      return ccListForModels(pool, brand, afamData && afamData.cc);
    }

    function fillModelOptions(models, brand, preferRaw) {
      if (mode !== "afam") {
        fillSelect(modelEl, models, phModel, !!brand, function (v) {
          return stripLeadingBrand(v, brand);
        });
        if (preferRaw && (models || []).indexOf(preferRaw) !== -1) modelEl.value = preferRaw;
        return;
      }
      var selectedCc = ccEl && ccEl.value ? String(ccEl.value) : "";
      var groups = [];
      var byLabel = {};
      (models || []).forEach(function (model) {
        var label = shortLabel(brand, model);
        if (!byLabel[label]) {
          byLabel[label] = { label: label, models: [] };
          groups.push(byLabel[label]);
        }
        byLabel[label].models.push(model);
      });
      groups.sort(function (a, b) {
        return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
      });
      modelEl.innerHTML = "";
      var opt0 = document.createElement("option");
      opt0.value = "";
      opt0.textContent = phModel;
      modelEl.appendChild(opt0);
      groups.forEach(function (g) {
        if (g.models.length > 1 && selectedCc) {
          g.models.forEach(function (model) {
            var full = document.createElement("option");
            full.value = model;
            full.textContent = stripLeadingBrand(model, brand);
            modelEl.appendChild(full);
          });
          return;
        }
        var opt = document.createElement("option");
        opt.value = g.models.length === 1 ? g.models[0] : MODEL_GROUP + g.label;
        opt.textContent = g.label;
        modelEl.appendChild(opt);
      });
      modelEl.disabled = !brand;
      var prefer = preferRaw || "";
      modelEl.value = "";
      if (!prefer) return;
      if (prefer.charAt(0) === MODEL_GROUP) {
        modelEl.value = prefer;
        if (modelEl.value !== prefer) modelEl.value = "";
        return;
      }
      var i;
      for (i = 1; i < modelEl.options.length; i++) {
        if (modelEl.options[i].value === prefer) {
          modelEl.value = prefer;
          return;
        }
      }
      if (!selectedCc) {
        var grouped = MODEL_GROUP + shortLabel(brand, prefer);
        modelEl.value = grouped;
        if (modelEl.value !== grouped) modelEl.value = "";
      }
    }

    function syncModelAndCc(brand, preferModel, preferCc) {
      var allModels = allModelsFor(brand);
      var ccMap = afamData && afamData.cc;
      if (!ccEl) {
        fillModelOptions(allModels, brand, preferModel);
        return { models: allModels, ccs: [] };
      }
      var ccs = ccListForModels(allModels, brand, ccMap);
      fillSelect(ccEl, ccs, phCc, !!brand && ccs.length > 0);
      var cc = preferCc || "";
      if (cc && ccs.indexOf(String(cc)) !== -1) ccEl.value = String(cc);
      else ccEl.value = "";
      var models = filterModelsByCc(allModels, ccEl.value || "", brand, ccMap);
      fillModelOptions(models, brand, preferModel);
      return { models: models, ccs: ccs };
    }

    function escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    var catalogCache = {};

    function fetchCollectionProducts() {
      if (catalogCache[collectionHandle]) return Promise.resolve(catalogCache[collectionHandle]);
      function page(n, acc) {
        return fetch("/collections/" + collectionHandle + "/products.json?limit=250&page=" + n)
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var list = (data && data.products) || [];
            acc = acc.concat(list);
            if (list.length < 250) {
              catalogCache[collectionHandle] = acc;
              return acc;
            }
            return page(n + 1, acc);
          });
      }
      return page(1, []);
    }

    function showHandleCards(handles) {
      var allow = {};
      handles.forEach(function (h) {
        allow[h] = true;
      });
      setStatus(handles.length + (handles.length > 1 ? " pièces pour cette moto" : " pièce pour cette moto"));
      fetchCollectionProducts()
        .then(function (products) {
          var grid = document.querySelector("#product-grid");
          var matched = products.filter(function (p) {
            return allow[p.handle];
          });
          if (!grid || !matched.length) {
            setStatus(matched.length ? "Aucune grille pour afficher les pièces." : "Aucune pièce pour cette moto.");
            return;
          }
          grid.innerHTML = matched
            .map(function (p) {
              var img = p.images && p.images[0] && p.images[0].src;
              var price = p.variants && p.variants[0] && p.variants[0].price;
              var priceLabel = price ? String(price).replace(".", ",") + " CHF" : "";
              var variants = p.variants || [];
              var inStock = variants.length === 0 || variants.some(function (v) { return v.available; });
              return (
                '<li class="grid__item"><a class="mm-afam-card" href="/products/' +
                p.handle +
                '">' +
                '<span class="mm-afam-card__media">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") +
                (inStock ? "" : '<span class="mm-afam-card__soldout">ÉPUISÉ</span>') +
                "</span>" +
                '<span class="mm-afam-card__title">' +
                escapeHtml(p.title) +
                "</span>" +
                (priceLabel ? '<span class="mm-afam-card__price">' + priceLabel + "</span>" : "") +
                "</a></li>"
              );
            })
            .join("");
          var count = document.querySelector("#ProductCountDesktop");
          if (count) count.textContent = matched.length + (matched.length > 1 ? " produits" : " produit");
          document.querySelectorAll(".pagination-wrapper, .pagination").forEach(function (el) {
            el.style.display = "none";
          });
        })
        .catch(function () {
          setStatus("Impossible d’afficher les pièces.");
        });
    }

    function productInCollection(p) {
      if (mode === "afam") {
        var cat = AFAM_HANDLES[collectionHandle] || "all";
        return cat === "all" || p.cat === cat;
      }
      if (mode === "freinage") {
        var fcat = FREINAGE_HANDLES[collectionHandle] || "all";
        if (fcat !== "all" && p.cat !== fcat) return false;
        var vendor = FREINAGE_VENDOR[collectionHandle] || "";
        return !vendor || p.vendor === vendor;
      }
      if (mode === "guidons") {
        var gcat = GUIDONS_HANDLES[collectionHandle] || "all";
        return gcat === "all" || p.cat === gcat;
      }
      return true;
    }

    function matchingHandles(brand, model, year) {
      var seen = {};
      var out = [];
      (afamData.products || []).forEach(function (p) {
        if (!productInCollection(p)) return;
        if (!productMatchesMoto(p, brand, model, year)) return;
        if (!p.h || seen[p.h]) return;
        seen[p.h] = true;
        out.push(p.h);
      });
      return out;
    }

    function goAfamResult(brand, model, year) {
      var handles = matchingHandles(brand, model, year);
      if (!handles.length) {
        setStatus("Aucune pièce pour cette moto.");
        applyAfamGridFilter(brand, model, year);
        return;
      }
      showHandleCards(handles);
    }

    function onSelectionChange(opts) {
      opts = opts || {};
      var brand = brandEl.value;
      var rawModel = modelEl.value;
      var year = yearEl.value;
      var type = typeEl ? typeEl.value : collectionHandle;
      var cc = ccEl ? ccEl.value : "";
      var model = concreteModel(brand, rawModel, cc);

      writeSession({
        brand: brand,
        model: rawModel,
        year: year,
        cc: cc,
        type: type || collectionHandle,
      });

      if (isFitmentMode) {
        if (!(brand && rawModel)) {
          if (window.location.search.indexOf("filter.") !== -1) {
            window.location.href = window.location.pathname;
            return;
          }
          applyAfamGridFilter("", "", "");
          return;
        }

        if (mode === "afam" && !afamSelectionReady()) return;
        goAfamResult(brand, model, year || "");
        return;
      }

      if (brand && model) {
        window.location.href = buildNativeFilterUrl(window.location.pathname, brand, model, year || "");
      }
    }

    function parseTypeLinks(raw) {
      if (!raw || raw === "[]") return [];
      if (raw.charAt(0) === "[") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return [];
        }
      }
      return raw.split("||").map(function (chunk) {
        var parts = chunk.split("::");
        return { handle: parts[0], label: parts.slice(1).join("::") };
      });
    }

    function populateTypeSelect() {
      if (!showType || !typeEl) return;
      var links = parseTypeLinks(root.getAttribute("data-type-links") || "");
      if (!links.length) return;
      fillSelect(
        typeEl,
        links.map(function (l) {
          return l.handle;
        }),
        phType,
        true,
      );
      links.forEach(function (l, i) {
        typeEl.options[i + 1].textContent = l.label;
      });
      typeEl.value = "";
    }

    function bindTypeNavigation() {
      if (!typeEl) return;
      typeEl.addEventListener("change", function () {
        var target = typeEl.value;
        if (!target) return;
        writeSession({
          brand: brandEl.value,
          model: modelEl.value,
          year: yearEl.value,
          cc: ccEl ? ccEl.value : "",
          type: target,
        });
        window.location.href = "/collections/" + target;
      });
    }

    function bindCascadeAfam() {
      brandEl.addEventListener("change", function () {
        var brand = brandEl.value;
        syncModelAndCc(brand, "", "");
        setYearOptions([], false);
        if (!brand) {
          onSelectionChange({ skipYears: true });
        }
      });

      if (ccEl) {
        ccEl.addEventListener("change", function () {
          var brand = brandEl.value;
          var cc = ccEl.value;
          var prev = modelEl.value;
          var concrete = concreteModel(brand, prev, cc);
          var models = filterModelsByCc(allModelsFor(brand), cc, brand, afamData && afamData.cc);
          fillModelOptions(models, brand, concrete || (cc ? "" : prev));
          var chosen = concreteModel(brand, modelEl.value, cc);
          if (chosen) {
            var keptYear = yearEl.value;
            var years = setYearOptions(yearsFor(brand, chosen), true);
            if (keptYear && years.indexOf(keptYear) !== -1) yearEl.value = keptYear;
            else yearEl.value = "";
          } else {
            setYearOptions([], false);
          }
          onSelectionChange();
        });
      }

      modelEl.addEventListener("change", function () {
        var brand = brandEl.value;
        var raw = modelEl.value;
        if (!raw) {
          if (ccEl) {
            var allCcs = ccListForModels(allModelsFor(brand), brand, afamData && afamData.cc);
            fillSelect(ccEl, allCcs, phCc, !!brand && allCcs.length > 0);
          }
          setYearOptions([], false);
          writeSession({
            brand: brand,
            model: "",
            year: "",
            cc: ccEl ? ccEl.value : "",
            type: collectionHandle,
          });
          if (window.location.search.indexOf("filter.") !== -1) {
            window.location.href = window.location.pathname;
            return;
          }
          applyAfamGridFilter("", "", "");
          return;
        }
        if (ccEl) {
          var prevCc = ccEl.value;
          var ccs = ccsForModelChoice(brand, raw);
          fillSelect(ccEl, ccs, phCc, ccs.length > 0);
          if (prevCc && ccs.indexOf(String(prevCc)) !== -1) ccEl.value = String(prevCc);
          else ccEl.value = "";
        }
        var chosen = concreteModel(brand, raw, ccEl ? ccEl.value : "");
        var keptYear = yearEl.value;
        var years = setYearOptions(yearsFor(brand, chosen), !!chosen);
        if (!(keptYear && years.indexOf(keptYear) !== -1)) yearEl.value = "";
        onSelectionChange();
      });

      yearEl.addEventListener("change", function () {
        onSelectionChange();
      });
    }

    function bindCascadeNative() {
      brandEl.addEventListener("change", function () {
        var brand = brandEl.value;
        syncModelAndCc(brand, "", "");
        setYearOptions([], false);
      });
      if (ccEl) {
        ccEl.addEventListener("change", function () {
          var brand = brandEl.value;
          var prev = modelEl.value;
          var allModels = modelsForBrand(afamData && afamData.tree, brand);
          var models = filterModelsByCc(allModels, ccEl.value, brand, afamData && afamData.cc);
          fillModelOptions(models, brand, concreteModel(brand, prev, ccEl.value) || (ccEl.value ? "" : prev));
          setYearOptions([], false);
        });
      }
      modelEl.addEventListener("change", function () {
        if (brandEl.value && modelEl.value) onSelectionChange({ skipYears: true });
      });
      yearEl.addEventListener("change", onSelectionChange);
    }

    function restoreState() {
      var session = readSession();
      var urlFilters = parseUrlFilters();

      var brand = urlFilters.brand || "";
      var model = urlFilters.model || "";
      var year = urlFilters.year || "";
      if (mode !== "afam") {
        brand = brand || session.brand || "";
        model = model || session.model || "";
        year = year || session.year || "";
      }
      var cc = mode === "afam" ? "" : session.cc || (model ? extractCc(model) : "");

      if (isFitmentMode && afamData) {
        fillSelect(brandEl, mode === "afam" ? brandsForCurrent() : afamData.brands || [], phBrand, true);
        var effectiveYear = "";
        if (brand) {
          brandEl.value = brand;
          syncModelAndCc(brand, model, cc);
          if (model) {
            var years = setYearOptions(yearsFor(brand, model), true);
            if (year && years.indexOf(year) !== -1) {
              yearEl.value = year;
              effectiveYear = year;
            } else {
              yearEl.value = "";
            }
          } else {
            setYearOptions([], false);
          }
        } else {
          fillSelect(modelEl, [], phModel, false);
          if (ccEl) fillSelect(ccEl, [], phCc, false);
          setYearOptions([], false);
        }

        var gridCount = gridEl ? gridEl.querySelectorAll("#product-grid .grid__item").length : 0;
        if ((brand || model) && gridCount === 0) {
          setStatus("");
          return;
        }

        if (mode === "afam") {
          setStatus("");
          return;
        }

        applyAfamGridFilter(brand, model, effectiveYear);
        return;
      }

      if (afamData && afamData.brands) {
        fillSelect(brandEl, afamData.brands, phBrand, true);
        if (brand) {
          brandEl.value = brand;
          syncModelAndCc(brand, model, cc);
        }
        setYearOptions([], false);
      }
    }

    populateTypeSelect();
    bindTypeNavigation();

    if (fitmentUrl) {
      fetch(fitmentUrl)
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          afamData = json;
          restoreState();
          if (isFitmentMode) bindCascadeAfam();
          else bindCascadeNative();
        })
        .catch(function (err) {
          console.error("[mm-pieces-moto]", err);
          setStatus(formatStatus(root, "load-error", {}));
        });
    } else {
      restoreState();
    }

    brandEl.addEventListener("change", function () {
      if (!isFitmentMode && !afamData) onSelectionChange();
    });
    modelEl.addEventListener("change", function () {
      if (!isFitmentMode && !afamData) onSelectionChange();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-mm-pieces-moto]").forEach(init);
  });
})();
